import ArrowLeft from "@svg/new-design/arrow-left";

import Link from "next/link";
import { FC } from "react";

interface Props {
  link: string;
}

const LandingCardFooter: FC<Props> = ({ link }) => {
  return (
    <div className="body-sm text-fds-brand flex mt-1.5  items-center h-7   sm:h-8   gap-fds-2">
      مشاهده مجموعه آموزشی
      <ArrowLeft className="h-4 w-4" />
    </div>
  );
};
export default LandingCardFooter;
